@if(basket(); as _basket) {
<ul>
  @for(line of (_basket?.basket?.lines??[]); track line.id) {
  <li>
    <a [href]="line.productUrl">
      <span class="name">{{ line.name }}</span>
      <!-- <span class="brand">{{ line.brand }}</span>
      <span class="designer">{{ line.designer }}</span> -->
      <span class="quantity">{{ line.quantity }}</span>
      <span class="total-price">{{ line?.totalPrice?.salesPrice | price }}</span>
      <span class="unit-price">{{ line?.unitPrice?.salesPrice | price }}</span>
      @if((line?.addons?.length??0) > 0) {
      <ul class="addons">
        @for(addon of (line?.addons?.length??[]); track addon.id) {
        <li>
          <span role="heading"
                aria-level="3">{{ addon.name }}</span>
          <img [use]="addon.imageUrl"
               width="150"
               height="150"
               role="presentation">
        </li>
        }
      </ul>
      }
      <img class="img"
           [src]="line.imageUrl"
           [srcset]="line.srcset"
           handleError
           width="150"
           height="150"
           role="presentation">
    </a>
  </li>
  } @empty {
  <ng-content select="[empty-basket]"></ng-content>
  }
</ul>
} @else if(basket() == undefined) {
<ng-content select="[no-basket]"></ng-content>
} @else {
<ng-content select="[error-basket]"></ng-content>
}
